import {Component, OnInit} from '@angular/core';
import {UsanaObject} from "../../usana-object";
import {IMPVideoModule} from "../marketing-page.models";
import {LoggerService} from "../../common/logger.service";
import {MarketingPageUtil} from "../marketing-page-util";
import {TranslateService} from "../../translation/translate.service";

@Component({
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss'],
    standalone: false
})
export class VideoComponent extends UsanaObject implements OnInit {
    pageUrl: string;
    componentData: IMPVideoModule;
    useLocaleOverride: boolean;
    translationRoot: string;

    textStyle: string;
    backgroundColor: string;
    embedLink: string;

    constructor(
        private translateService: TranslateService,
        loggerService: LoggerService
    ) {
        super(loggerService);
    }

    ngOnInit(): void {
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl, this.componentData.name);
        this.textStyle = MarketingPageUtil.getTextStyleClass(this.componentData.textStyle);
        this.backgroundColor = MarketingPageUtil.getBackgroundColor(this.componentData.backgroundColor);
        this.translateService.translate(this.translationRoot + '.embed', this.useLocaleOverride).then((data: string) => {
            this.embedLink = data;
        });
    }
}
